// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination-module--pagination--1e4jL","wrapper":"Pagination-module--wrapper--cgD-p","light":"Pagination-module--light--3fVFA"};